export enum enmStopFreeSaleReportTypes {
    Agency = 1,
    Market = 2,
    Rooms = 3,
    RoomType = 4,
    Board = 5
}
